<template>
    <div class="content-box first" v-loading="listLoading">
        <div v-if="dataList.length > 0" class="page-list-box">
            <div v-for="(item, index) in dataList" :key="index"
                :class="['list-item', 'clearfix', item.isRead == 1 ? 'active' : '']">
                <div class="icon fl"></div>
                <div class="info">
                    <div class="title">
                        {{ item.title }}
                        <span class="time">{{ $utils.formatDate(item.sendTime, 'yyyy.MM.dd HH:mm') }}</span>
                    </div>
                    <div class="content m-t-2 color-info">
                        <span v-html="item.content"></span>
                        <template v-if="item.type == 1">
                            <el-button type="text" @click="$router.push(`/manage/album/detail/${item.targetId}`)">
                                查看详情
                            </el-button>
                        </template>
                        <template v-else-if="item.type == 4">
                            <el-button type="text" @click="$router.push(`/manage/album/share/${item.targetId}`)">
                                专辑平台链接
                            </el-button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <el-empty description="没有相关通知"></el-empty>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="prev, pager, next" :total="data.totalCount || 0"></el-pagination>
        </div>
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1
};
export default {
    data() {
        return {
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            listLoading: true
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表数据
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: '/msg/sys_msg/view/sys_msg_list',
                method: 'post',
                params: { ...this.params }
            })
                .then(res => {
                    const {
                        state,
                        msg,
                        result: { sysMsgPageData }
                    } = res.data;
                    if (state && sysMsgPageData) {
                        this.data = sysMsgPageData;
                        this.dataList = sysMsgPageData.result || [];
                        this.dataList.map(item => {
                            item.content = item.content.replace(/\/#/g, '');
                        });
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        }
    }
};
</script>

<style lang="scss" scoped>
.list-item {
    margin-bottom: 35px;

    &.active {
        .title {
            color: #999;

            .time {
                color: #999;
            }
        }

        .color-info {
            color: #999;

            .el-button {
                color: #999;
            }
        }
    }

    .icon {
        width: 32px;
        height: 32px;
        margin-right: 14px;
    }

    .info {
        overflow: hidden;
        border-bottom: 1px #dcdfe6 solid;
        padding-bottom: 35px;

        .title {
            font-weight: 500;
            position: relative;

            .time {
                color: #7f91a3;
                font-size: 12px;
                margin-left: 20px;
                font-weight: normal;
            }

            .right {
                right: 0px;
                font-size: 11px;
                position: absolute;
                top: 0px;
                line-height: 21px;
                color: #999;
            }
        }

        .content {
            line-height: 26px;

            ::v-deep a {
                text-decoration: underline;
            }
        }
    }

    &:last-child {
        .info {
            border-bottom: 0;
        }
    }
}
</style>
